// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Ouroboros_Models_Brands_Email from "../Ouroboros.Models.Brands.Email/index.js";
import * as Ouroboros_Models_Brands_ErrorMessageText from "../Ouroboros.Models.Brands.ErrorMessageText/index.js";
import * as Ouroboros_Models_Core_ErrorHandlers from "../Ouroboros.Models.Core.ErrorHandlers/index.js";
import * as Ouroboros_Programs_Capabilities from "../Ouroboros.Programs.Capabilities/index.js";
import * as Ouroboros_Programs_TsBridgeHelpers from "../Ouroboros.Programs.TsBridgeHelpers/index.js";
import * as Ouroboros_Services_Clients_Interop_Option from "../Ouroboros.Services.Clients.Interop.Option/index.js";
import * as Ouroboros_Services_Clients_Interop_Task from "../Ouroboros.Services.Clients.Interop.Task/index.js";
import * as Ouroboros_Services_Clients_Interop_TaskEither from "../Ouroboros.Services.Clients.Interop.TaskEither/index.js";
import * as Ouroboros_Services_Clients_Interop_Types from "../Ouroboros.Services.Clients.Interop.Types/index.js";
import * as TsBridge_Class from "../TsBridge.Class/index.js";
import * as TsBridge_DefaultImpls from "../TsBridge.DefaultImpls/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var bind = /* #__PURE__ */ Control_Bind.bind(TsBridge_Monad.bindTsBridgeM);
var tsBridge = /* #__PURE__ */ TsBridge_Class.tsBridge(/* #__PURE__ */ Ouroboros_Services_Clients_Interop_Types.tsBridgeIOts(/* #__PURE__ */ TsBridge_Class.tsBridgeRecord(/* #__PURE__ */ TsBridge_DefaultImpls.tsBridgeRecord1()(/* #__PURE__ */ TsBridge_DefaultImpls.tsBridgeRecordRLCons(/* #__PURE__ */ TsBridge_Class.tsBridgeByTok(TsBridge_Class.tsBridgeBoolean))(TsBridge_DefaultImpls.tsBridgeRecordRLNil)({
    reflectSymbol: function () {
        return "success";
    }
})))));
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var PasswordResetRequestAction = function (x) {
    return x;
};
var tsBridgePasswordResetRequ = {
    tsBridge: function (v) {
        return bind(tsBridge(Type_Proxy["Proxy"].value))(function (valueType) {
            return pure(Ouroboros_Programs_TsBridgeHelpers.brandIntersection(valueType)("PasswordResetRequestAction")("__brandPasswordResetRequestAction"));
        });
    }
};
var toLoadingErrorInput = function (errorValue) {
    var statusCode = (function () {
        if (errorValue.statusCode instanceof Data_Maybe.Nothing) {
            return Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit);
        };
        if (errorValue.statusCode instanceof Data_Maybe.Just) {
            return Ouroboros_Services_Clients_Interop_Option.some(errorValue.statusCode.value0);
        };
        throw new Error("Failed pattern match at Ouroboros.Programs.Controllers.PasswordResetRequest (line 104, column 7 - line 106, column 40): " + [ errorValue.statusCode.constructor.name ]);
    })();
    var message = Ouroboros_Models_Core_ErrorHandlers.passwordResetErrorMessage({
        type: errorValue.type,
        message: errorValue.message,
        statusCode: statusCode
    });
    return {
        message: message.message,
        info: message.info
    };
};
var runPasswordResetRequestAction = function (v) {
    return v;
};
var runLoadingAction = function (v) {
    return v;
};
var readState = function (v) {
    return v;
};
var mkPasswordResetRequestAction = PasswordResetRequestAction;
var missingEmailError = {
    message: /* #__PURE__ */ Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText("Email is required to request a reset link."),
    info: /* #__PURE__ */ Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)
};
var markSubmitted = function (env) {
    return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setSuccess));
    })(Ouroboros_Services_Clients_Interop_Task.fromIO(Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(env.submitted))(true)));
};
var handlePasswordResetError = function (env) {
    return function (errorValue) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setError(toLoadingErrorInput(errorValue))));
    };
};
var submitAndHandle = function (env) {
    return function (request) {
        return Ouroboros_Services_Clients_Interop_TaskEither.fold(handlePasswordResetError(env))(function (v) {
            return markSubmitted(env);
        })(env.requestPasswordReset(request));
    };
};
var submitEmail = function (env) {
    return function (emailValue) {
        return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
            return submitAndHandle(env)({
                email: Ouroboros_Models_Brands_Email.makeEmail(emailValue)
            });
        })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setLoading)));
    };
};
var submitPasswordReset = function (env) {
    return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setError(missingEmailError)));
    })(function (emailValue) {
        return submitEmail(env)(emailValue);
    })(readState(Ouroboros_Programs_Capabilities.optionStateHandleRead(env.email)));
};
var mkPasswordResetRequestController = function (env) {
    return {
        submit: mkPasswordResetRequestAction(Ouroboros_Programs_Capabilities.runTaskRunner(env.taskRunner)(submitPasswordReset(env))),
        navigateToLogin: mkPasswordResetRequestAction(Ouroboros_Programs_Capabilities.runControllerAction(Ouroboros_Programs_Capabilities.runNavigateAction(env.navigate)(env.loginRoute)))
    };
};
var documentationPath = "/documentation/drafting/frontend-program-builder/controllers/password_reset_request_controller.md";
export {
    PasswordResetRequestAction,
    mkPasswordResetRequestController,
    runPasswordResetRequestAction,
    documentationPath,
    tsBridgePasswordResetRequ
};
//# sourceMappingURL=index.js.map
